export function getFileFromEvent(event: Event): File {
  const target = event.target as HTMLInputElement;

  return (target.files as FileList)[0];
}
